<template>
    <div style="background-color: #fafafa;">
		<div class="searchBox">
			<van-search class="search-box" background="#2D7FC7" shape="round" v-model="value" placeholder="搜索客户、地址和电话、经销商" show-action @search="onSearch" @input="onSearch"
						@cancel="onSearch" @clear="onSearch">
				<div style="padding-top: 10px;" slot="action" @click="showFilterPop()"><van-icon name="filter-o" size="20"  color="#fafafa"/></div>
			</van-search>
		</div>
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
				<div style="width: 100%;" v-for="(item, index) in list" class="card" :key="item.uuid">
					<table class="layout" style="width: 100%;" >
						<tr style="width: 100%;">
							<td style="width: 60%;" @click="openDetail(item.uuid, item.serialNumber, item.orderStatusname, item.creatorIdname)">
								<div class="header">
									<span class="title">{{item.serialNumber}}</span>
								</div>
							</td>
							<td style="width: 40%;text-align: left;">
								<div style="width: 100%;display: inline-block; position: relative;">
									<span style="color: red;font-weight: bold;">{{item.orderStatusname}}</span>
									<van-icon v-if="item.orderStatus === '10' && item.creatorId === userId" @click="deleteOrderForm(item.uuid)" name="delete" size="30px" style="position: absolute;right: 40px;bottom: -5px;"/>
									<van-icon v-if="item.orderStatus === '10' && item.creatorId === userId" @click="submitOrderForm(item.uuid)" name="passed" size="30px" style="position: absolute;right: 10px;bottom: -5px;"/>
								</div>
							</td>
						</tr>
						<tr style="width: 100%;">
							<td colspan="2" class="content" style="width: 100%;">
								<p><span>收货人：</span><span>{{ item.customerName }}</span></p>
								<p><span>联系方式：</span><span>{{ item.arrivalMobile }}</span></p>
								<p style="width: 100%;"><span>收货地址：</span><span>{{ item.arrivalAddress }}</span></p>
								
							</td>
						</tr>
						<tr style="width: 100%;">
							<td class="content" style="width: 50%;">
								<p><span>下单人:</span><span>{{item.dealerName}}&nbsp;&nbsp;&nbsp;{{item.creatorIdname}}</span></p>
								<p><span>{{item.createTime}}</span></p>
							</td>
							<td class="content" style="width: 50%;font-size: 15px;">
								<p><span>共{{item.mainQuantities}}组,合计:</span></p>
								<p><span>¥{{item.mainCostAmount}}</span></p>
								<p v-if="isLeader === '1' || checkPermission('查看销售单价')"><span style="color: #ff3300">{{item.mainAmount}}</span></p>
							</td>
						</tr>
						<tr style="width: 100%;">
							<td class="content" colspan="2">
								<p><span>出库时间:</span><span>{{ item.outputTime }}</span></p>
								<p><span>物流信息:</span><span>{{item.deliveryInfo}}</span></p>
							</td>
						</tr>
					</table>
				</div>
			</van-list>
		</van-pull-refresh>
		<van-popup v-model="showFilter" closeable position="bottom" :style="{ height: '80%' }"
				   :close-on-click-overlay="false">
			<van-nav-bar title="发送和分类" left-text="取消" right-text="确定"
						 @click-left="onFilterClickLeft()" @click-right="onFilterClickRight()" />
			<table class="layout">
				<tr>
					<td>
						<van-field-acb v-model="orderStatus" dict="rad_order_status" label="分类"></van-field-acb>
						<van-field-date v-model="startTime" type="date" format="yyyy-MM-dd" label="开始日期"></van-field-date>
						<van-field-date v-model="endTime" format="yyyy-MM-dd" type="date" label="结束日期"></van-field-date>
					</td>
				</tr>
			</table>
		</van-popup>
    </div>
</template>

<script>
	import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Icon, Toast, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
	import VanFieldAcb from '../../components/VanFieldAcb';
	import VanFieldDate from "../../components/VantFieldDate";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
	import formService from "../../service/formService";
	import userInfo from "../../store/userInfo";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				value: '',
				showFilter: false,
				orderStatus: "",
				startTime: "",
				endTime: "",
				isLeader: "2"
            }
        },
      
        components: {
			VanFieldAcb,
			VanFieldDate,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
			[NavBar.name]: NavBar,
        },
		computed:{
			userId() {
				return this.$store.getters.getUserId;
			}
		},
		created: async function () {
			let resp = await dealerOrderService.getDealerInfo();
			if (resp.data.Status === "1" && resp.data.Data) {
				this.isLeader = resp.data.Data.isAdvisor || "2";
			}
		},
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getRadOrderList(this.pageIndex, this.value, this.orderStatus, this.startTime, this.endTime);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
                    if(item.deliveryInfo && item.deliveryInfo.length > 22){
                    	let temp = item.deliveryInfo;
						item.deliveryInfo = temp.substring(0, 22);
						item.deliveryInfo += "...";
					}
					if(item.remark && item.remark.length > 22){
						let temp = item.remark;
						item.remark = temp.substring(0, 22);
						item.remark += "...";
					}
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			showFilterPop(){
				this.showFilter = true;
			},
			onFilterClickLeft(){
				this.showFilter = false;
			},
			onFilterClickRight(){
				this.showFilter = false;
				this.onSearch();
			},
			openDetail(orderId, serialNumber, orderStatus, staffName){
				this.$router.push({path:"orderDetail",  query:{uuid: orderId, serialNumber: serialNumber, orderStatus: orderStatus, staffName: staffName, isLeader: this.isLeader}} );
			},
			async submitOrderForm(orderId) {
				Toast.loading({
					duration:0,
					message: '处理中...',
					forbidClick: true
				});
				let resp = await formService.submitForm(orderId, "销售订单", "","",  "");
				if (resp.data.Status === "1") {
					Toast.clear();
					Toast.success('下单提交成功！');
					this.onSearch();
				} else {
					Toast.clear();
					Toast.fail(resp.data.Data);
					this.onSearch();
				}
			},
			async deleteOrderForm(orderId) {
				Dialog.confirm({
					title: '',
					message: '确定删除此订单吗？'
				}).then(() => {
					this.deleteOrder(orderId);
				}).catch(() => {
					return;
				});
			},
			async deleteOrder(orderId){
				let resp = await dealerOrderService.deleteOrderById(orderId);
				if (resp.data.Status === "1"){
					Toast.success("删除成功！");
					this.onRefresh();
				} else {
					Toast.fail(resp.data.Message);
					this.onRefresh();
				}
			},
        }
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		overflow: hidden;

	}
	.searchBox {
		height: 3rem;
		box-sizing: border-box;
		margin-bottom: 2rem;
		top: 0;
		position:fixed;
		width: 100%;
		background-color: #2D7FC7;
		z-index:999;
	}
</style>